export function isShareReportRoute() {
    const regex = /\/raport\/[a-zA-Z].*/gm;
    return !!regex.exec(window.location.pathname)
}

export function getShareReportHash() {
    const regex = /\/raport\/([0-9a-zA-Z]*)\/?/gm;
    const result = regex.exec(window.location.pathname);
    if (result && result[1]) {
        return result[1]
    }

    return null;
}

export function getIconUrl(fileName: string) {
    const reqHost = window.location.host == 'localhost:3000' ? 'http://localhost:8000/' : '/';
    return reqHost + 'wp-content/plugins/rainwater-calculator/public/icons/' + fileName;
}